import React from 'react';
import {Grid, Input, Dropdown} from 'semantic-ui-react';
import {setErrorMessage, clearErrorMessage} from '../../../../../common/components/form/common';
import {tabKeyCode, enterKeyCode} from '../../../../../common/constants/keyCodes';
import {types} from '../../../../../common/dictionaries/forms';
import {Label, ColumnValue} from './common/index';

function fetchChassis(event, fetchChassisInfo) {
  const chassis = event.target.value;
  if (!chassis) {
    return;
  }
  fetchChassisInfo(chassis);
}

function getChassisInfo(event, fetchChassisInfo) {
  if (!(event.keyCode === tabKeyCode || event.keyCode === enterKeyCode)) {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  fetchChassis(event, fetchChassisInfo);
}

function getTypesOptions() {
  return Object.keys(types).map((item) => {
    return {'text': types[item], 'value': item};
  });
}

const ChassisInfoRow = ({
  generalInfo,
  isDisplayMode,
  fetchChassisInfo,
  onChangeValue,
  onChangeInputField,
  chassisInfo,
}) => {
  return (
    <Grid.Row>
      <Label width={1} label='Tipo' />
      <Grid.Column width={2}>
        <Dropdown
          selection
          options={getTypesOptions()}
          search
          value={generalInfo.type}
          onChange={(e, {value}) => onChangeValue('type', value)}
          disabled={isDisplayMode}
          placeholder='Tipo'
        />
      </Grid.Column>
      <Label width={1} label='Chasis' />
      <Grid.Column width={3}>
        <Input
          type='text'
          required
          value={generalInfo.chassis || ''}
          onChange={(e, {value}) => onChangeInputField('chassis', value)}
          onInvalid={(event) =>
            setErrorMessage('Por favor, llene este campo', event)
          }
          onInput={(event) => clearErrorMessage(event)}
          onKeyDown={(event) => getChassisInfo(event, fetchChassisInfo)}
          disabled={isDisplayMode}
          placeholder='Chasis'
          autoComplete='off'
        />
      </Grid.Column>
      <Label width={1} label='Motor' />
      <ColumnValue width={2} value={chassisInfo.motor} />
      <Label width={1} label='Año Modelo' />
      <ColumnValue width={1} value={chassisInfo.modelYear} />
      <Label width={1} label='Modelo' />
      <ColumnValue width={3} value={chassisInfo.modelName} />
    </Grid.Row>
  );
};

export default ChassisInfoRow;
